import script from "./HintsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./HintsManager.vue?vue&type=script&setup=true&lang=js"

import "./HintsManager.vue?vue&type=style&index=0&id=7f29ec35&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f29ec35"]])

export default __exports__